module.exports = __webpack_public_path__ + "static/img/company.e0d4adf6.png";